// authSlices.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createUser, GoogleCreate, loginUser, logout } from "./authAPI";

const initialState = {
  user: null,
  loading: false,
  status: "idle",
  error: null,
};

export const createUserAsync = createAsyncThunk(
  "auth/createUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await createUser(data);
      return response;
    } catch (error) {
      console.error("createUserAsync error:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const googleCreateAsync = createAsyncThunk(
  "auth/googleCreate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GoogleCreate(data);
      return response.data || response;
    } catch (error) {
      console.error("googleCreateAsync error:", error);
      return rejectWithValue(
        error?.response?.data?.message || error.message || "Something went wrong"
      );
    }
  }
);

export const loginUserAsync = createAsyncThunk(
  "auth/loginUser",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await loginUser(userData);
      return response;
    } catch (error) {
      console.error("loginUserAsync error:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const logoutAsync = createAsyncThunk("auth/logout", async ({ accessToken }) => {
  try {
    const response = await logout(accessToken);
    return response;
  } catch (error) {
    console.error("logoutAsync error:", error);
    return error;
  }
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Google
      .addCase(googleCreateAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(googleCreateAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.user = action.payload;
      })
      .addCase(googleCreateAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      })
      // Register
      .addCase(createUserAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createUserAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.user = action.payload;
      })
      .addCase(createUserAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      })
      // Login
      .addCase(loginUserAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loginUserAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.user = action.payload?.user;
      })
      .addCase(loginUserAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      })
      // Logout
      .addCase(logoutAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(logoutAsync.fulfilled, (state) => {
        state.status = "idle";
        state.user = null;
      });
  },
});

export const selectUserResponse = (state) => state.auth?.user;
export default authSlice.reducer;